import { Heading } from '@components/Layout/Service';
import { ourDedicatedProcess } from '@components/pages/services/dedicated-development/constant';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { FC, useState } from 'react';
import { ourITStaffAugmentationProcess } from '../../constant';

interface InterfaceITStaffAugmentationProcess {
  title?: string;
  imageUrl?: string;
  imageAlt?: string;
  iconUrl?: string;
  processData?: any;
  extraButton?: React.ReactChildren | boolean;
}

const EXTRA_BUTTON = {
  DEDICATED_TEAM: {
    id: 'dedicated-team',
    text: 'industry.get_a_full_service',
  },
  STAFF_AUGMENTATION: {
    id: 'staff-augmentation',
    text: 'industry.extend_your_in_house',
  },
};

const ITStaffAugmentationProcess: FC<InterfaceITStaffAugmentationProcess> = ({
  title,
  imageUrl,
  imageAlt,
  iconUrl,
  processData,
  extraButton = false,
}) => {
  const { t } = useTranslation();

  const [extraButtonText, setExtraButtonText] = useState(
    EXTRA_BUTTON.DEDICATED_TEAM,
  );

  const handleChangeProcess = (process) => () => setExtraButtonText(process);

  return (
    <div className="it-staff-augmentation-process">
      <Heading title={title || t('service.blockchainConceptTitle')} />

      {extraButton && (
        <div className="extra-button">
          <button
            className={
              extraButtonText.id === EXTRA_BUTTON.DEDICATED_TEAM.id &&
              'extra-button-active'
            }
            onClick={handleChangeProcess(EXTRA_BUTTON.DEDICATED_TEAM)}
          >
            {t('service.txtDedicatedTeam')}
          </button>
          <button
            className={
              extraButtonText.id === EXTRA_BUTTON.STAFF_AUGMENTATION.id &&
              'extra-button-active'
            }
            onClick={handleChangeProcess(EXTRA_BUTTON.STAFF_AUGMENTATION)}
          >
            {t('service.txtStaffAugmentation')}
          </button>
        </div>
      )}

      <div className="it-staff__container">
        <div className="image">
          <Image
            src={
              imageUrl ||
              (extraButtonText !== EXTRA_BUTTON.DEDICATED_TEAM
                ? '/images/services/dedicated-development/dedicated-process-image.webp'
                : '/images/services/dedicated-development/staff-process-image.webp')
            }
            alt={imageAlt || 'IT staff augmentation process'}
            layout="fill"
            quality={100}
            objectFit="cover"
          />
        </div>

        <div className="process-container">
          {extraButton && (
            <div
              dangerouslySetInnerHTML={{
                __html: extraButtonText && t(extraButtonText.text),
              }}
              className="extra-text"
            />
          )}

          {(
            processData &&
            (extraButton &&
            extraButtonText.id === EXTRA_BUTTON.DEDICATED_TEAM.id
              ? ourDedicatedProcess(t)
              : ourITStaffAugmentationProcess(t))
          )?.map(({ title, content }, index: number) => (
            <div className="process" key={index}>
              <div className="concept">
                <span className="concept__step">
                  {t('common.step', {
                    number: index + 1,
                  })}
                </span>
                <div className="concept__dot" />
                <span className="concept__title">{title}</span>
              </div>

              <div className="description">
                <div className="icon">
                  <Image
                    src={iconUrl || '/icons/icon-keyboard_return.svg'}
                    alt="keyboard-return"
                    layout="fill"
                    quality={100}
                    objectFit="cover"
                  />
                </div>

                <div
                  className="desc-text"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ITStaffAugmentationProcess;
